const IconRefine = (): JSX.Element => {
  return (
    <>
      <path
        d="M12.5 3.99992V1.33325M12.5 3.99992C11.0272 3.99992 9.83331 5.19383 9.83331 6.66658C9.83331 8.13934 11.0272 9.33325 12.5 9.33325M12.5 3.99992C13.9727 3.99992 15.1666 5.19383 15.1666 6.66658C15.1666 8.13934 13.9727 9.33325 12.5 9.33325M4.49998 19.9999C5.97274 19.9999 7.16665 18.806 7.16665 17.3333C7.16665 15.8605 5.97274 14.6666 4.49998 14.6666M4.49998 19.9999C3.02722 19.9999 1.83331 18.806 1.83331 17.3333C1.83331 15.8605 3.02722 14.6666 4.49998 14.6666M4.49998 19.9999V22.6666M4.49998 14.6666V1.33325M12.5 9.33325V22.6666M20.5 19.9999C21.9727 19.9999 23.1666 18.806 23.1666 17.3333C23.1666 15.8605 21.9727 14.6666 20.5 14.6666M20.5 19.9999C19.0272 19.9999 17.8333 18.806 17.8333 17.3333C17.8333 15.8605 19.0272 14.6666 20.5 14.6666M20.5 19.9999V22.6666M20.5 14.6666V1.33325"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );
};

export default IconRefine;
